import { TextField } from '@shared/ui';

import { matchesPhrase, TURN_OFF_PHRASE } from './typed-phrase';

/**
 * The alert sentence, any Salesforce wording and the typed phrase of a turn-off
 * dialog (ACR-1598). The dialog disables its confirm until `matchesPhrase`.
 */
export function TurnOffConfirmFields({
    sentence,
    salesforceNotes,
    text,
    onChange,
    disabled,
}: {
    sentence: string;
    salesforceNotes: readonly string[];
    text: string;
    onChange: (next: string) => void;
    disabled: boolean;
}) {
    return (
        <div className="flex flex-col gap-3">
            <div
                role="alert"
                className="rounded-lg border border-danger-line bg-danger-surface px-3.5 py-2.5 text-[12.5px] leading-relaxed text-danger-text"
            >
                <p className="font-semibold">{sentence}</p>
                {salesforceNotes.map((note) => (
                    <p key={note} className="mt-1.5 text-danger-muted">
                        {note}
                    </p>
                ))}
            </div>
            <TextField
                label={`Type "${TURN_OFF_PHRASE}" to confirm`}
                value={text}
                onChange={onChange}
                disabled={disabled}
                autoFocus
                error={
                    text.length > 0 && !matchesPhrase(text)
                        ? 'The text must match exactly, including capitals and spaces.'
                        : undefined
                }
            />
        </div>
    );
}
